export default "__VITE_ASSET__CEoQuBOV__"